import React from 'react'
import { FormGroup, Label, Input } from 'reactstrap'

export default function SelectAssignmentType (props) {
  let options = <option value='' key='nullAssignmentTypeOption'></option>
  if (props.assignmentOptions) {
    options = props.assignmentOptions.map( (option, n) => {
      return <option value={option} key={'assignmentTypeOption' + n}>{option}</option>
    })
    options.splice(0, 0, <option value='' key='nullAssignmentTypeOption'></option>)
  }

  return (
    <FormGroup>
      <Label htmlFor='assignmentType'>Assignment Type</Label>
      <Input
        name='assignmentType'
        id='assignmentType' 
        type='select' 
        value={props.assignmentType}
        onChange={(e) => props.handleChange(e)}  
      >
        {options}
      </Input>
    </FormGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentsManage/SelectAssignmentType.js